
        import {fetchClearskyApi} from './api/core';

        const dataEndpoint = 'status/time-behind'

        async function fetchData() {
            try {
                const data = await fetchClearskyApi('v1', dataEndpoint);
                if (data) { 
                    displayData(data);
                } else {
                    console.error('Failed to fetch data');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        function displayData(data) {
            const timeBehindTableBody = document.getElementById('time-behind-table-body');
            timeBehindTableBody.innerHTML = ''; // Clear previous data
            const row = document.createElement('tr');
            const timeBehindCell = document.createElement('td');
            const timeBehindValue = data.data['time behind'];

            if (timeBehindValue === 'in sync' || timeBehindValue === 'unknown') {
                timeBehindCell.textContent = timeBehindValue;
            } else {
                timeBehindCell.textContent = `time behind: ${timeBehindValue}`;
            }

            row.appendChild(timeBehindCell);
            timeBehindTableBody.appendChild(row);
        }

        fetchData(); // Initial call
        setInterval(fetchData, 10000); // Refresh data every 10 seconds
    